import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { createNetworkStatusReducer } from "pubnub-redux";

import history from "../history";
import patientdetail from "./patient/reducer";
import signin from "./signin/reducer";
import survey from "./survey/reducer";
import dashboard from "./dashboard/reducer";
import messagepatient from "./messagePatient/reducer";
import messagefamily from "./messageFamily/reducer";
import videochat from "./videoChat/reducer";
import flash from "./flash/reducer";
import session from "./session/reducer";
import orgs from "./organizations/reducer";
import securemessage from "./secureMessage/reducer";
import psmobile from "./psMobileTestPage/reducer";
import upload from "./uploadPatients/reducer";
import pubnub from "./pubnub/reducer";
import messaging from "./messaging/reducer";
import attachments from "./attachment.reducer";

export default combineReducers({
  dashboard,
  patientdetail,
  router: connectRouter(history),
  securemessage,
  signin,
  messagefamily,
  messagepatient,
  survey,
  videochat,
  flash,
  session,
  orgs,
  psmobile,
  upload,
  pubnubStatus: createNetworkStatusReducer(false),
  pubnub,
  messaging,
  attachments
});
